import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { TermSeparator } from './separators';
export var NumberFilterOperationType = /*#__PURE__*/ function(NumberFilterOperationType) {
    NumberFilterOperationType["IsGreaterThan"] = "IsGreaterThan";
    NumberFilterOperationType["IsLessThan"] = "IsLessThan";
    NumberFilterOperationType["Is"] = "Is";
    NumberFilterOperationType["IsNotExactly"] = "IsNotExactly";
    NumberFilterOperationType["IsEmpty"] = "IsEmpty";
    NumberFilterOperationType["IsNotEmpty"] = "IsNotEmpty";
    return NumberFilterOperationType;
}({});
export const NumberFilterOperationTypes = [
    "Is",
    "IsNotExactly",
    "IsGreaterThan",
    "IsLessThan",
    "IsEmpty",
    "IsNotEmpty"
];
export const isOptional = (type)=>type === "IsEmpty" || type === "IsNotEmpty";
const isValid = (filter)=>{
    switch(filter.type){
        case "Is":
        case "IsNotExactly":
        case "IsGreaterThan":
        case "IsLessThan":
            return filter.value != null;
        default:
            return true;
    }
};
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case "IsEmpty":
        case "IsNotEmpty":
            return type;
        case "IsGreaterThan":
        case "Is":
        case "IsNotExactly":
        case "IsLessThan":
            return [
                type,
                filter.value == null ? 'null' : filter.value
            ].join(TermSeparator);
        default:
            return unreachable(filter);
    }
};
const parse = (value, field)=>{
    const [type_string, meta] = value.split(TermSeparator);
    const type = pascalCase(type_string);
    switch(type){
        case "IsEmpty":
        case "IsNotEmpty":
            return {
                field,
                type
            };
        case "IsGreaterThan":
        case "Is":
        case "IsNotExactly":
        case "IsLessThan":
            {
                const number = JSON.parse(`${meta}`);
                return {
                    field,
                    type,
                    value: number == null ? undefined : number
                };
            }
        default:
            return unreachable(type);
    }
};
export const NumberFieldFilter = {
    isValid,
    toString,
    parse
};
// TODO: this is a tmp function for determining if number filter needs conditional input;
export const _isConditionalInputNeeded = (arg)=>[
        "Is",
        "IsNotExactly",
        "IsGreaterThan",
        "IsLessThan"
    ].includes(arg.type);
